(function () {
    'use strict';

    angular
        .module('controlEditModule')
        .controller('ControlAddController', Controller);

    Controller.$inject = ['$scope', 'topBarService'];

    function Controller($scope, topBarService) {

        topBarService.setTitleAndIcon('New Control', 'fa fa-eye');

        $scope.control = {};
    }
})();